<h2 mat-dialog-title>צור תגובות באמצעות AI</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="ai-form">

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>פרומפט</mat-label>
      <textarea matInput formControlName="prompt" rows="3"></textarea>
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>מספר תגובות</mat-label>
        <input matInput type="number" formControlName="commentCount">
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>שפה</mat-label>
        <input matInput formControlName="language">
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">ביטול</button>
  <button mat-raised-button color="primary" (click)="onOk()" [disabled]="form.invalid">אישור</button>
</mat-dialog-actions>
